var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.875 3H2.5C2.16848 3 1.85054 3.1317 1.61612 3.36612C1.3817 3.60054 1.25 3.91848 1.25 4.25V13C1.25 13.3315 1.3817 13.6495 1.61612 13.8839C1.85054 14.1183 2.16848 14.25 2.5 14.25H11.25C11.5815 14.25 11.8995 14.1183 12.1339 13.8839C12.3683 13.6495 12.5 13.3315 12.5 13V8.625",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5625 2.06249C11.8111 1.81385 12.1484 1.67416 12.5 1.67416C12.8516 1.67416 13.1889 1.81385 13.4375 2.06249C13.6861 2.31113 13.8258 2.64836 13.8258 2.99999C13.8258 3.35162 13.6861 3.68885 13.4375 3.93749L7.5 9.87499L5 10.5L5.625 7.99999L11.5625 2.06249Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.91aa5ef5b624c3fcec76ed4d824632e6.svg";
export { ForwardRef as ReactComponent };